import axios from "axios";
import { useState } from "react";
import { getLastWeekRange } from "../getLastWeekRange";

export const useAnalytics = () => {
  const [dateRange, setDateRange] = useState(getLastWeekRange());
  const [bookings, setBookings] = useState([]);
  const [previousYearBookings, setPreviousYearBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataMode, setDataMode] = useState("Booked Data");

  const fetchBookings = async () => {
    if (!dateRange[0] || !dateRange[1]) return;
    setLoading(true);
    try {
      const start = new Date(dateRange[0]);
      start.setUTCHours(0, 0, 0, 0); // Normalize start date to midnight UTC
      const end = new Date(dateRange[1]);
      end.setUTCHours(23, 59, 59, 999); // Normalize end date to end of day UTC

      // Fetch current year data
      const currentResponse = await axios.get("/api/bookings/reportbookings", {
        params: {
          startDate: start.toISOString(),
          endDate: end.toISOString(),
          mode: dataMode === "Booked Data" ? "booked" : "stayed",
        },
      });

      // Calculate previous year date range
      const previousStart = new Date(start);
      previousStart.setUTCFullYear(start.getUTCFullYear() - 1);
      const previousEnd = new Date(end);
      previousEnd.setUTCFullYear(end.getUTCFullYear() - 1);

      console.log("Fetching previous year data for range:", {
        start: previousStart.toISOString(),
        end: previousEnd.toISOString(),
        mode: dataMode === "Booked Data" ? "booked" : "stayed",
      });

      const previousResponse = await axios.get("/api/bookings/reportbookings", {
        params: {
          startDate: previousStart.toISOString(),
          endDate: previousEnd.toISOString(),
          mode: dataMode === "Booked Data" ? "booked" : "stayed",
        },
      });

      console.log("Current year bookings:", currentResponse.data);
      console.log("Previous year bookings:", previousResponse.data);

      setBookings(currentResponse.data);
      setPreviousYearBookings(previousResponse.data);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateRangeChange = (option) => {
    const today = new Date();
    let startDate, endDate;

    switch (option) {
      case "Last Week":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 7);
        endDate = new Date(today);
        endDate.setDate(today.getDate() - 1);
        break;
      case "Last Month":
        startDate = new Date(today);
        startDate.setMonth(today.getMonth() - 1);
        startDate.setDate(1);
        endDate = new Date(today);
        endDate.setMonth(today.getMonth(), 0);
        break;
      case "Last 14 Days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 14);
        endDate = new Date(today);
        endDate.setDate(today.getDate() - 1);
        break;
      case "Last 60 Days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 60);
        endDate = new Date(today);
        endDate.setDate(today.getDate() - 1);
        break;
      case "Last 90 Days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 90);
        endDate = new Date(today);
        endDate.setDate(today.getDate() - 1);
        break;
      default:
        return;
    }

    setDateRange([startDate, endDate]);
  };

  return {
    fetchBookings,
    handleDateRangeChange,
    dataMode,
    setDataMode,
    bookings,
    previousYearBookings,
    loading,
    dateRange,
    setDateRange,
  };
};
